import React, { useEffect, useRef, useContext, useState } from "react";
import { useQuery } from "react-query";
import Layout from "../../Layout";
import { useCaptureEvent } from "../../../hooks/useCaptureEvent";
import SharedDataContext from "../../../SharedDataContext";
import { initializeDevice } from "../../../apis/phoneInventory";
import DialerSplash from "../../containers/DialerAI/DialerSplash";
import { Skeleton } from "../../ui/skeleton";

export default function DialerPage() {
  const captureEvent = useCaptureEvent();
  const hasTrackedPageViewRef = useRef(false);
  const userData = useContext(SharedDataContext);
  const { activeWorkspace } = userData || {};
  const [hasDialerAccess, setHasDialerAccess] = useState(null);

  useEffect(() => {
    if (!hasTrackedPageViewRef.current) {
      captureEvent("SET_Dialer_PageView");
      hasTrackedPageViewRef.current = true;
    }
  }, [captureEvent]);

  // Dialer access Checking
  const { isLoading } = useQuery(
    ["initialize_device", activeWorkspace?.id],
    () => initializeDevice({ options: { headers: { "X-Workspace-ID": activeWorkspace?.id }, skipErrorToast: true } }),
    {
      enabled: !!activeWorkspace?.id,
      retry: false,
      onSuccess: () => {
        setHasDialerAccess(true);
      },
      onError: (error) => {
        console.log("Dialer access denied:", error?.response?.status);
        setHasDialerAccess(false);
      },
    }
  );
  if (hasDialerAccess === false) {
    return (
      <Layout className="pt-0 pb-0">
        <DialerSplash />
      </Layout>
    );
  }
  return (
    <Layout className="pt-0 pb-0">
      <iframe
        src={`${process.env.REACT_APP_DIALER_BASE_URL}`}
        width="100%"
        // height="850px"
        frameBorder="0"
        allow="microphone; camera; autoplay; encrypted-media"
        style={{
          border: "none",
          background: "transparent",
          height: "100vh"
        }}
      />
    </Layout>
  );
} 